
import React from "react";
import Social from "./Social";

const Footer = () => (
    <div className="alignFooter">
<div className="color">
    <div className="footer">
<Social/>
</div>
<div className="footer" >
    <p>1409 N Ogden St, Denver, CO 80218, US</p>
</div>
</div>

    <p className="footer">This is website is made for study purposes only</p>
    <p className="footer name">by Maria Melnikova </p>
    <p className="footer name"><a href="mailto:mariamelnikovamm@gmail.com">mariamelnikovamm@gmail.com</a></p>
  </div>

);

export default Footer;